import { render, staticRenderFns } from "./VIPlevel.vue?vue&type=template&id=68ed2c51&scoped=true&"
import script from "./VIPlevel.vue?vue&type=script&lang=js&"
export * from "./VIPlevel.vue?vue&type=script&lang=js&"
import style0 from "./VIPlevel.vue?vue&type=style&index=0&id=68ed2c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed2c51",
  null
  
)

export default component.exports